import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { push } from 'connected-react-router';
import { Container, Card, Form, Spinner, Row, Col, Button } from 'react-bootstrap';
import { useForm, FormProvider } from 'react-hook-form';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAsterisk } from '@fortawesome/free-solid-svg-icons';

import PageTitle from 'src/components/general/PageTitle';
import { required, cancel, save, newCaption, caption, year } from 'src/utils/label';

import { CAPTION_LIST } from 'src/utils/constants';
import { tryAddNewCaption } from 'src/redux/caption/captionActionCreator';
import { getCaptionCreateIsFetching } from 'src/redux/caption/captionReducer';
import CaptionForm  from 'src/components/forms/caption/captionForm';

const UserNewPage = props => {

	const dispatch = useDispatch();

	const hookFormMethods = useForm();
    const { handleSubmit } = hookFormMethods;

	const captionCreateIsFetching = useSelector(state => getCaptionCreateIsFetching(state));

	const onFormSubmit = data => {
		const year = data?.year;
		const caption = data?.caption;

		const params = {
			caption: caption,
			year: year
		}

		dispatch(tryAddNewCaption(params));
	};

	return <Container fluid className='mb-5'>
		<Card>

			<PageTitle text={caption} />

			<Container fluid>
				<Card className='mb-3'>

					<Card.Header>
						<h6 className='mb-0'>{newCaption}</h6>
					</Card.Header>

					<Card.Body >

						<Row>
							<Col xs={8}>
								<h6 className='mb-4 text-black-color'>
								</h6>
							</Col>

							<Col xs={4} className='text-right font-weight-bold font-italic'>
								<span className='text-danger d-flex mandatory-label'>
									<FontAwesomeIcon icon={faAsterisk} className='mb-2 mr-1 text-danger mandatory-asterisk' />
									{required}
								</span>
							</Col>
						</Row>
						<FormProvider {...hookFormMethods} >
							<Form onSubmit={handleSubmit(onFormSubmit)} autoComplete='off'>
								
								<CaptionForm />

								<div className='d-flex justify-content-around mt-4 mb-3'>
									<Button 
										variant='danger' 
										size='lg'
										disabled={captionCreateIsFetching} 
										onClick={() => dispatch(push(CAPTION_LIST))}
									>
										{cancel}
									</Button>

									<span className={(captionCreateIsFetching ? '' : 'hidden')}>
										<Spinner className='spinner-border text-danger' animation='border' />
									</span>

									<Button 
										type='submit' 
										variant='success' 
										size='lg'
										disabled={captionCreateIsFetching}
									>
										{save}
									</Button>
								</div>

							</Form>
						</FormProvider>
					</Card.Body>
				</Card>
			</Container>
		</Card>
	</Container>;
};

export default UserNewPage;